<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card
        class="mb-0"
        no-body
      >
        <b-card-header
          class="d-flex justify-content-center align-items-center"
          header-tag="header"
        >
          <b-img
            :src="require('@/assets/images/logo/PRYM-blue-small.png')"
            height="50%"
            alt="PRYM Logo"
          />
          <h4 class="mb-1 mt-3">
            Sign up and start your adventure here
          </h4>
          <p class="mb-0">
            Connect your Physical and Digital Worlds!
          </p>
        </b-card-header>

        <b-card-body>
          <b-tabs
            v-show="activeTab > 0"
            v-model="activeTab"
            fill
            content-class="mt-2"
          >
            <b-tab
              title="1. Personal"
              title-item-class="step-tab"
            />
            <b-tab
              title="2. Company"
              title-item-class="step-tab"
            />
            <b-tab
              title="3. Password"
              title-item-class="step-tab"
            />
          </b-tabs>

          <div
            v-show="activeTab === 0"
            key="personal"
          >
            <sign-up-personal
              :new-user="newUser"
              @nextTab="nextTab"
            />
          </div>
          <div
            v-show="activeTab === 1"
            key="company"
          >
            <sign-up-company
              :new-user="newUser"
              @nextTab="nextTab"
              @prevTab="prevTab"
            />
          </div>
          <div
            v-show="activeTab === 2"
            key="password"
          >
            <sign-up-password
              :new-user="newUser"
              @prevTab="prevTab"
              @signUp="signUp"
            />
          </div>

          <div v-show="activeTab === 0">
            <div class="divider my-2">
              <div class="divider-text">
                or
              </div>
            </div>
            <!-- social buttons -->
            <div class="auth-footer-btn d-flex justify-content-center">
              <b-button
                block
                variant="outline-danger"
              >
                Sign up with Google
              </b-button>
            </div>
            <b-card-text class="text-center mt-2">
              <span>Already have an account? </span>
              <b-link :to="{ name: 'auth-login' }">
                <span>Sign in instead</span>
              </b-link>
            </b-card-text>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BLink,
  BCardText,
  BImg,
  BCardBody,
  BCardHeader,
  BButton,
  BTab,
  BTabs,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { Auth } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid'

import SignUpPersonal from './SignUpPersonal.vue'
import SignUpCompany from './SignUpCompany.vue'
import SignUpPassword from './SignUpPassword.vue'

export default {
  components: {
    BImg,
    BCard,
    BLink,
    BCardBody,
    BCardHeader,
    BCardText,
    BButton,
    SignUpPersonal,
    SignUpCompany,
    SignUpPassword,
    BTab,
    BTabs,
  },

  data() {
    return {
      activeTab: 0,
      newUser: {
        firstName: '',
        lastName: '',
        email: '',

        workspace: '',
        companySize: '',
        jobTitle: '',

        password: '',
        passwordConfirm: '',
        status: '',
        inviteCode: '',
      },
      companySizeOptions: [
        { text: '1-10', value: '1-10' },
        { text: '11-50', value: '11-50' },
        { text: '51-200', value: '51-200' },
        { text: '201-500', value: '201-500' },
        { text: '501-1000', value: '501-1000' },
        { text: '1000+', value: '1000+' },
      ],

      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    nextTab() {
      this.activeTab += 1
    },
    prevTab() {
      this.activeTab -= 1
    },
    async signUp() {
      try {
        const userAttributes = {
          'custom:first_name': this.newUser.firstName,
          'custom:last_name': this.newUser.lastName,
          'custom:workspace': this.newUser.workspace,
          'custom:workspaceId': uuidv4(),
        }
        await Auth.signUp({
          username: this.newUser.email,
          password: this.newUser.password,
          attributes: userAttributes,
          clientMetadata: {
            companySize: this.newUser.companySize,
            jobTitle: this.newUser.jobTitle,
          },
        })
        this.$router.push({
          name: 'signedup',
          params: { email: this.newUser.email },
        })
      } catch (error) {
        this.handleSignUpError(error)
      }
    },
    handleSignUpError(error) {
      // console.log(error)
      let errorMessage

      switch (error.code) {
        case 'UsernameExistsException':
          errorMessage = 'Email already exists'
          break
        case 'InvalidPasswordException':
          errorMessage = 'Invalid password'
          break
        case 'InvalidParameterException':
          errorMessage = 'Invalid parameters'
          break
        case 'NetworkError':
          errorMessage = 'A network error occurred. Please check your internet connection'
          break
        default:
          errorMessage = error.message
      }

      this.toast(errorMessage)
    },
    toast(message) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: message,
            icon: 'EditIcon',
            variant: 'danger',
          },
        },
        {
          timeout: 4000,
        },
      )
    },

    validationForm() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          this.signUp()
        }
      })
    },
  },
}
</script>

<style lang="scss">
.step-tab {
  pointer-events: none;
}
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/pages/page-auth.scss";
.auth-wrapper.auth-v1 {
  background: url("https://uploads-ssl.webflow.com/61489b3e5856f80b844d9a07/61489b3e5856f824ec4d9b48_background-pricing-tech-ui-kit-webflow-template.svg");
}
.btn-secondary {
  border-color: #171663 !important;
  background-color: #171663 !important;
}
a {
  color: #7844fc;
}
</style>
